import { useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { ANIMATION_TIME } from '../config';

const IconCont = ({ onClick, initVisible, setInitVisible }) => {
  const [opacity, setOpacity] = useState(1);

  const _onClick = () => {
    setInitVisible(true);
    setOpacity(0);
    setTimeout(() => onClick(), ANIMATION_TIME);
  };

  return (
    <div className={formatClassname(["icon-row", !opacity && 'closed', !initVisible && 'no-animation'])}>
      <InfoCircleOutlined
        onClick={_onClick}
        className="cursor-pointer"
      />
    </div>
  )
}

export default IconCont;
